import PerformanceTrendQAReport from "./PerformanceTrendQAReport.component";

export default PerformanceTrendQAReport;
